import firebase from 'firebase/app'
import { notification } from 'ant-design-vue'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'

const firebaseConfig = {
  apiKey: 'AIzaSyCZw2zvWLCShGn6SgZBhRWuu7tK_sDuEA8',
  authDomain: 'nursingexampro.firebaseapp.com',
  databaseURL: 'https://nursingexampro.firebaseio.com',
  projectId: 'nursingexampro',
  storageBucket: 'nursingexampro.appspot.com',
  messagingSenderId: '88353323783',
  appId: '1:88353323783:web:fd95224289748fcf68a3a2',
  measurementId: 'G-YD2795GS8R',
}

// Initialize
firebase.initializeApp(firebaseConfig)
export const firebaseAuth = firebase.auth()
export const firebaseFirestore = firebase.firestore()
export const firebaseFunctions = firebase.functions()

// Log in
export async function login(email, password) {
  return firebaseAuth
    .signInWithEmailAndPassword(email, password)
    .then(() => true)
    .catch(error => {
      notification.warning({
        message: error.code,
        description: error.message,
      })
    })
}

// Register
export async function register(email, password, name) {
  return firebaseAuth
    .createUserWithEmailAndPassword(email, password)
    .then(response => {
      if (response.user) {
        const uid = response.user.uid
        console.log(uid + ' signed up successfully')
        firebaseFirestore
          .collection('users')
          .doc(uid)
          .set({
            uid: uid,
            displayName: name,
            email: email,
            emailVerified: false,
            questionsViewed: [],
            questionsSaved: [],
            role: 'learner',
            signupDate: Math.floor(new Date().getTime() / 1000),
            status: {
              isSubscribed: false,
              expireDate: null,
              tier: 'basic',
            },
          })
          .then(
            console.log('User added to Firestore'),
          )
          .catch(error => {
            console.log(error)
            notification.warning({
              message: error.code,
              description: error.message,
            })
          })
      }
      return true
    })
    .catch(error => {
      console.log(error)
      notification.warning({
        message: error.code,
        description: error.message,
      })
    })
}

// Get current user (no longer used)
export async function currentAccount() {
  let userLoaded = false
  function getCurrentUser(auth) {
    return new Promise((resolve, reject) => {
      if (userLoaded) {
        resolve(firebaseAuth.currentUser)
      }
      const unsubscribe = auth.onAuthStateChanged(user => {
        userLoaded = true
        unsubscribe()
        const getUserData = async () => {
          if (user) {
            console.log('user.uid: ' + user.uid)
            const userFields = await firebaseFirestore
              .collection('users')
              .doc(user.uid)
              .get()
              .then(snapshot => {
                return snapshot.data()
              })
            console.log('User loaded.')
            console.log(userFields)
            const mergedUser = Object.assign(user, {
              id: user.uid,
              name: userFields.name,
              role: userFields.role,
              avatar: userFields.photoUrl,
              tier: userFields.tier,
              questionsSaved: userFields.questionsSaved,
              questionsViewed: userFields.questionsViewed,
            })
            return mergedUser
          }
          return user
        }
        resolve(getUserData())
      }, reject)
    })
  }
  return getCurrentUser(firebaseAuth)
}

// Log out
export async function logout() {
  return firebaseAuth.signOut().then(() => true)
}

// FieldValue
export const fv = firebase.firestore.FieldValue
